import React from "react";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import TermsContent from "./TermsContent";
import AuthBanner from "../../reusable/AuthBanner";
class TermAndConditions extends React.Component {
  render() {
    return (
      <div>
        <AuthBanner title="Terms and Conditions" />
        <TermsContent />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(TermAndConditions);



// WEBPACK FOOTER //
// ./src/pages/termAndConditions/index.js